import cx from "classnames";

import Box, { BoxProps } from "ds/components/Box";

import styles from "./styles.module.css";

type CardWrapperProps = BoxProps & {
  variant?: "secondary" | "primary";
  ref?: React.ForwardedRef<HTMLDivElement>;
};

const CardWrapper = ({
  className,
  variant = "primary",
  children,
  ref,
  ...restProps
}: CardWrapperProps) => {
  const elementClass = cx(styles.wrapper, styles[variant], className);

  return (
    <Box direction="column" className={elementClass} {...restProps} ref={ref}>
      {children}
    </Box>
  );
};

CardWrapper.displayName = "DS.Card.Wrapper";

export default CardWrapper;
